import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui-kit";
import { Gauge, Flame } from "lucide-react";

export default function Workload() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/workload").then((r) => setData(r.data)).catch(() => {}); }, []);

  const max = Math.max(1, ...data.map((d) => d.active_count));
  const capacity = (n) => (n >= 6 ? "Overloaded" : n >= 3 ? "Balanced" : "Available");
  const capCls = (n) => (n >= 6 ? "text-red-500" : n >= 3 ? "text-amber-500" : "text-emerald-500");

  return (
    <div className="space-y-4" data-testid="workload-page">
      <div>
        <h1 className="font-heading text-2xl font-bold uppercase tracking-tight sm:text-3xl flex items-center gap-2"><Gauge size={24} /> Workload Balancer</h1>
        <p className="text-sm text-muted-foreground">Technician capacity & active assignments heatmap.</p>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {data.map((d) => (
          <Card key={d.technician.id} className="p-4" data-testid={`workload-${d.technician.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-semibold">{d.technician.full_name}</div>
                <div className="font-mono text-[11px] uppercase text-muted-foreground">{d.technician.security_clearance}</div>
              </div>
              <span className={`font-mono text-xs font-bold ${capCls(d.active_count)}`}>{capacity(d.active_count)}</span>
            </div>
            <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-muted">
              <div className={`h-full rounded-full ${d.active_count >= 6 ? "bg-red-500" : d.active_count >= 3 ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${(d.active_count / max) * 100}%` }} />
            </div>
            <div className="mt-2 flex items-center justify-between font-mono text-xs text-muted-foreground">
              <span>{d.active_count} active jobs</span>
              {d.urgent_count > 0 && <span className="flex items-center gap-1 text-red-500"><Flame size={12} /> {d.urgent_count} urgent</span>}
            </div>
          </Card>
        ))}
        {data.length === 0 && <p className="text-sm text-muted-foreground">No technicians found.</p>}
      </div>
    </div>
  );
}
